<div class="application-description-container">
  <div class="header-container">
    <span class="title">Application description</span>
    <mat-icon class="close-icon" [mat-dialog-close]="">close</mat-icon>
  </div>
  <div class="description-container">
    <p>
      {{ dialogData?.appDescription }}
    </p>
  </div>
</div>